
    <div class="main-footer">
      <div class="flex-display logoCont">
          <img src="assets/images/logo-regioneveneto.svg">
      </div>
      <div class="flex-display contVen">
        <span class="rven"><b>Regione Veneto</b></span>
          <ul class="external-links">
              <li><a class="footer-style" href="#">Accessibilità</a></li>
              <li><a class="footer-style" href="#">Privacy</a></li>
              <li><a class="footer-style" href="#">Note Legali</a></li>
              <li><a class="footer-style" href="#">Informativa Cookie</a></li>
              <li><a class="footer-style" href="http://www.regione.veneto.it" target="_black">www.regione.veneto.it</a></li>
          </ul>
      </div>
    </div>

